var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemarkAddedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5H2V21.5H16V9.5H12V5.5ZM0 4.4918C0 3.94405 0.44749 3.5 0.9985 3.5H13L17.9997 8.5L18 22.4925C18 23.0489 17.5551 23.5 17.0066 23.5H0.9934C0.44476 23.5 0 23.0447 0 22.5082V4.4918ZM8 12.5V9.5H10V12.5H13V14.5H10V17.5H8V14.5H5V12.5H8Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    width: 12,
    height: 12,
    rx: 6,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6665 7.32137L18.4967 3.49121L19.5055 4.5L14.6665 9.5L11.5 6.5L12.6042 5.25899L14.6665 7.32137Z",
    fill: "#E5D9B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemarkAddedIcon);
export default __webpack_public_path__ + "static/media/RemarkAddedIcon.d59db9e3c88accf0998aeac21a638702.svg";
export { ForwardRef as ReactComponent };